import { getTrackerRender } from 'Modules/business/yandex-metrics';


export const TrackerRender = getTrackerRender({
    options: {
        accurateTrackBounce: true,
        clickmap: true,
        trackLinks: true,
        webvisor: true,
    },
});
